import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getClapCount, getClapCountSync, initializeClapCounts, subscribeToClapCount } from '../utils/clapManagerV2';

/**
 * ClapCounter component
 * Displays the current clap count for a user
 */
function ClapCounter() {
  const { currentUser } = useAuth();
  const [count, setCount] = useState(10); // Default to 10
  const [loading, setLoading] = useState(true);
  
  // Get and update the clap count
  useEffect(() => {
    const userId = currentUser?.uid || 'anonymous_user';
    let unsubscribe = () => {};
    
    // Get initial count from cache first (sync)
    const cachedCount = getClapCountSync(userId);
    setCount(cachedCount);
    
    // Initialize and fetch from Firebase
    const initialize = async () => {
      try {
        await initializeClapCounts(userId);
        const currentCount = await getClapCount(userId);
        setCount(currentCount);
        setLoading(false);
        
        // Subscribe to real-time updates
        unsubscribe = subscribeToClapCount(userId, (newCount) => {
          setCount(newCount);
        });
      } catch (error) {
        console.error('Error initializing clap count:', error);
        setLoading(false);
      }
    };
    
    initialize();
    
    // Listen for count changes (legacy support)
    const handleClapCountChanged = (e) => {
      const { userId: eventUserId, count: newCount } = e.detail;
      if (eventUserId === userId) {
        setCount(newCount);
      }
    };
    
    // Add event listener
    document.addEventListener('clapCountChanged', handleClapCountChanged);
    
    // Clean up
    return () => {
      document.removeEventListener('clapCountChanged', handleClapCountChanged);
      unsubscribe();
    };
  }, [currentUser]);
  
  return (
    <div style={{
      display: 'inline-block',
      backgroundColor: count === 0 ? '#666' : '#4CAF50',
      color: 'white',
      fontWeight: 'bold',
      padding: '3px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      cursor: count === 0 ? 'pointer' : 'default',
      transition: 'all 0.2s ease'
    }}
    onClick={() => {
      if (count === 0) {
        // Trigger the refill modal
        window.dispatchEvent(new CustomEvent('openClapRefillModal'));
      }
    }}
    title={count === 0 ? 'Click to get more claps' : `${count} claps left`}
    >
      👏 {count} {count === 0 && '(Get more)'}
    </div>
  );
}

export default ClapCounter;